import React from 'react'
import HealthcareBanner from '../../Industries/Healthcare/HealthcareBanner';
import ProductCards from './ProductCards';

export default function ProductListing({initialData}) {

    const BannerData = {
        buttonText: "our Products",
        buttonLink: "/product-listing",
        title: "Laundry Solutions Built For You",
        description: "Engineered for diverse laundry operations, our machines adapt to your unique needs; delivering reliability, efficiency, and performance at scale while maximizing sustainability and operational success.",
        image: "/assets/images/product/product-list.webp"
    };

  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "/product-listing",
        name: "our Products"
      }
    ]

  }



    return (
        <>
            <HealthcareBanner data={BannerData} breadcrumb={bannerData.breadcrumb}/>
            <ProductCards initialData={initialData} />
        </>
    )
}
